import { createModel } from '@rematch/core';
import { getOneMonthPeriod } from '@/std/datetime';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { RootModel } from '..';
import type { CobrancaBoletoState } from './types';
import { effects } from './effects';

const initialState: CobrancaBoletoState = {
    // VALORES PARA DRAWERS
    dadosCompartilhar: null,

    // DRAWER
    drawerTab: 'Detalhes',
    gerarListaPDFs: initReduxFn,
    // EFFECTS
    get: initReduxFn,
    getOne: initReduxFn,
    getRetornosBancarios: initReduxFn,

    // TABELAS
    getTable: {
        // FILTROS
        filterDataRangeEmissao: getOneMonthPeriod(),
        filterNome: '',
        filterStatus: '',

        // LOADING NA TABELA PARA MOSTRAR ALGUMA AÇÃO EXECUTANDO
        loadingTable: false,

        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // LINHA SELECIONADAS
        selectedRow: undefined,
        selectedRows: [],

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },

        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,

        // UPDATE TABLE ON CHANGES
        updateTable: false,
    },
    post: initReduxFn,
    postRetornosBancarios: initReduxFn,
    postRetornosBancariosFile: initReduxFn,
    put: initReduxFn,
    remove: initReduxFn,
    showDrawerCompartilhar: false,

    // MOSTRAR DRAWERS
    showDrawerDetalhes: false,
    showFiltroAvancado: false,
    totalizador: initReduxFn,
};

export const CobrancaBoletoModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<CobrancaBoletoState>(),
    state: initialState,
});
